import React from "react";
import "./RouteLoadingFallback.css";

/**
 * Suspense fallback for the route-level React.lazy() boundaries in App.tsx.
 * Deliberately tiny and dependency-free — it is itself part of the eager
 * bundle (every lazy route falls back to it), so it must never grow.
 *
 * The very first paint is handled by the pure-CSS boot shell baked into
 * index.html (see src/boot.css); this only covers a SUBSEQUENT lazy route
 * transition, once the app has already mounted.
 */
const RouteLoadingFallback: React.FC = () => (
  <div className="route-loading" role="status" aria-label="Loading">
    <div className="route-loading__spinner" />
  </div>
);

export default RouteLoadingFallback;
